export default {"src":"/_next/static/media/insight_generation_predictive_modeling.2725d77f.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};